import { Directive, ElementRef, HostListener, Input, Injector, ViewChild, ViewChildren } from '@angular/core';
import Swal from 'sweetalert2';
import { NgControl } from '@angular/forms';
import { Optional } from '@angular/core';

@Directive({
  selector: '[appInputRestriction]',
  standalone: true
})

export class InputRestrictionDirective {

  inputElement: ElementRef;
  private control: NgControl;
  @Input('InputRestriction') InputRestriction: ElementRef;
  @Input('appInputRestriction') appInputRestriction: string;
  arabicRegex = '[\u0600-\u06FF]';
  private _oldvalue: string = "";

  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];



  constructor(public el: ElementRef, injector: Injector, @Optional() private ngControl: NgControl) {
    this.inputElement = el;
    try {
      this.control = injector.get(NgControl)
    }
    catch (e) {
    }

  }


  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    
    if (
      this.navigationKeys.indexOf(event.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Allow: Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Allow: Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Allow: Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) || // Allow: Cmd+X (Mac)
      (event.key === 'z' && event.metaKey === true) ||
      (event.key === 'z' && event.ctrlKey === true) // for ctrl - z
    ) {
      // let it happen, don't do anything
      return;
    }
    if (this.appInputRestriction === 'decimalOnly') {
      //const input = this.el.nativeElement;
      //const value = input.value;

      //const number = parseFloat(value);
      //if (!isNaN(number)) {
      //  input.value = number.toFixed(2);
      //} else {
      //  input.value = '';
      //}
    }

    if (this.appInputRestriction === 'noSpecialChars') {
      this.noSpecialChars(event);
    }

    if (this.appInputRestriction === 'allowfewSpecialChars') {
      this.allowfewSpecialChars(event);
    }
    if (this.appInputRestriction === 'CompanyName') {
      this.CompanyName(event)
    }
    if (this.appInputRestriction === 'allowSpecialChars') {
      this.allowSpecialChars(event);
    }

    if (this.appInputRestriction === 'allowMinusValue') {

      this.allowMinusValue(event);
    }

    if (this.appInputRestriction === 'postCode_UK') {

      this.postCode_UK(event);
    }

    if (this.appInputRestriction === 'alphaNumeric') {
      this.alphaNumeric(event);
    }
    if (this.appInputRestriction === 'numericOnly') {
        this.numericOnly(event);
    }
    if (this.appInputRestriction === 'DigitsNegativeOnly') {
      this.acceptNegativevalues(event);
    }
    if (this.appInputRestriction === 'acceptOnlyNumbers') {
      this.acceptOnlyNumbers(event);
    }

    if (this.appInputRestriction === 'addressType') {
      this.addressType(event);
    }

    if (this.appInputRestriction === 'addressTax') {
      this.addressTax(event);
    }

    if (this.appInputRestriction === 'c40Status') {
      this.c40Status(event);
    }
    if (this.appInputRestriction === 'phoneNumber_UK') {
      this.phoneNumber_UK(event);
    }

    if (this.appInputRestriction === 'hpage') {
      this.hpage(event);
    }

    if (this.appInputRestriction === 'email') {
      this.emailType(event);
    }

    if (this.appInputRestriction === 'onlyAlphabets') {
      this.onlyAlphabets(event);
    }
    if (this.appInputRestriction === 'Trim') {
      this.Trim(event);
    }
    if (this.appInputRestriction === 'searchCharityCommission') {
      
      this.searchCharityCommission(event)
    }
  }


  onlyAlphabets(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    //allow these charecters
    if (new RegExp(/[a-zA-Z]/).test(ch)) {
      return;
    }
    e.preventDefault();
  }




  hpage(event: any) {


    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    //allow these charecters
    if ((new RegExp('^[a-zA-Z0-9\s/&]*$').test(ch))) {
      return;
    }
    e.preventDefault();
  }



  c40Status(event: any) {


    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }


    const ch = String.fromCharCode(e.keyCode);

    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    //allow these charecters
    if ((new RegExp(/^[a-zA-Z0-9\s&()'@/,-.]$/).test(ch))) {
      return;
    }

    //const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();

  }



  addressTax(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    if ((new RegExp(/^[^=~!\\\#+$~%'"^|_:;?<>\[\]{}@]$/).test(ch))) {
      return;
    }
    //const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }


  @HostListener('blur', ['$event']) onblur(event: any) {

    if (
      this.navigationKeys.indexOf(event.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Allow: Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Allow: Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Allow: Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) || // Allow: Cmd+X (Mac)
      (event.key === 'z' && event.metaKey === true) ||
      (event.key === 'z' && event.ctrlKey === true) // for ctrl - z
    ) {
      // let it happen, don't do anything
      return;
    }
    if (this.appInputRestriction === 'decimalOnly') {
      const value = this.el.nativeElement.value;
      const number = parseFloat(value);
      if (!isNaN(number)) {
        this.el.nativeElement.value = number.toFixed(2);  
      }
    }

    if (this.appInputRestriction === 'noSpecialChars') {
      this.noSpecialChars(event);
    }
    if (this.appInputRestriction === 'allowfewSpecialChars') {
      this.allowfewSpecialChars(event)
    }
    if (this.appInputRestriction === 'CompanyName') {
      this.CompanyName(event)
    }


    if (this.appInputRestriction === 'postCode_UK') {

      this.postCode_UK(event);
    }
    if (this.appInputRestriction === 'allowSpecialChars') {

      this.allowSpecialChars(event);
    }
    if (this.appInputRestriction === 'alphaNumeric') {

      this.alphaNumeric(event);
    }
    if (this.appInputRestriction === 'numericOnly') {

      this.numericOnly(event);
    }
    if (this.appInputRestriction === 'DigitsNegativeOnly') {
      this.acceptNegativevalues(event);
    }
    if (this.appInputRestriction === 'acceptOnlyNumbers') {
      this.acceptOnlyNumbers(event);
    }
    if (this.appInputRestriction === 'addressType') {
      this.addressType(event);
    }
    if (this.appInputRestriction === 'addressTax') {
      this.addressTax(event);
    }
    if (this.appInputRestriction === 'c40Status') {
      this.c40Status(event);
    }
    if (this.appInputRestriction === 'phoneNumber_UK') {
      this.phoneNumber_UK(event);
    }
    if (this.appInputRestriction === 'hpage') {
      this.hpage(event);
    }
    if (this.appInputRestriction === 'onlyAlphabets') {
      this.onlyAlphabets(event);
    }

    if (this.appInputRestriction === 'searchCharityCommission') {
      
      this.searchCharityCommission(event)
    }

  }





  






  //for h supplementary page 


  searchCharityCommission(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Allow Tab
    if (event.key === 'Tab') {
      return;
    }

    // Prevent space at first position
    if (event.key === ' ' && input.selectionStart === 0) {
      event.preventDefault();
      return;
    }

    const ch = event.key;

    // Allow special characters + alphanumeric (your existing rule)
    const validCharRegex = /^[a-zA-Z0-9\s!#%&@'/\-.]$/;
    const arabicRegex = new RegExp(this.arabicRegex);

    if (!validCharRegex.test(ch) && !arabicRegex.test(ch)) {
      event.preventDefault();
      return;
    }

    // Determine type
    const isNumeric = /^[0-9]+$/.test(value + ch);
    const isAlpha = /^[a-zA-Z\s]+$/.test(value + ch);

    // Enforce limits
    if (isNumeric && value.length >= 8) {
      event.preventDefault();
      return;
    }

    if (!isNumeric && value.length >= 160) {
      event.preventDefault();
      return;
    }
  }



  allowSpecialChars(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    if (new RegExp(/^[a-zA-Z0-9\s&\/\\#,+()$~%.€'":*?<>-{}@£]+$/).test(ch)) {
      return;
    }
    //const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  addressType(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    if ((new RegExp(/^[^!`£$%\^\*\+€=_\{\}\[\];:@~#?<>|\\]+$/).test(ch))) {
      return;
    }
    //const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  allowfewSpecialChars(event: any) {
    
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    if (new RegExp(/^[a-zA-Z0-9\s#%&@'/\-.]+$/).test(ch)) {
      return;
    }
    //const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }
  CompanyName(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    if (new RegExp(/^[a-zA-Z0-9\s&()'\-,.@\/]+$/).test(ch)) {
      return;
    }
    //const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  //email validation
  emailType(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if ((event.keyCode === 32) && event.target.selectionStart == 0) {
      e.preventDefault();
    }
    if (new RegExp(/^[a-zA-Z0-9\s\-._+@]+$/).test(ch)) {
      return;
    }
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  allowMinusValue(event: any) {

    //this.amount_Range(event)
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replace(/^0+/, '');
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode;  // k = event.charCode;  (Both can be used)
    if (!k || k === 8) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if (new RegExp(/\d/).test(ch)) {
      return;
    }
    if (ch == "-" && (this.inputElement.nativeElement.value == "" || event.target.selectionStart == 0)
      && !(event.target.value[0] === '-')) {
      return;
    }
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  //numberonly
  numericOnly(event: KeyboardEvent) {

    
    // Allow Tab key for navigation
    if (event.key === 'Tab') {
      return;
    }

    // Allow Backspace, Delete, and arrow keys for navigation
    if (!event.key || event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      return;
    }

    // Check if the character is a digit (0-9)
    if (/^[0-9]$/.test(event.key)) {

      return; // Allow the input
    }
    else {
     // this.control.reset()
  
      this.el.nativeElement.value=this.el.nativeElement.value
        .replace(/\D/g, '').trim();
     
      return;
    }

    // Prevent the default action for invalid characters
    event.preventDefault();
  }



  //alphanumeric
  alphaNumeric(event: any) {

    //const initalValue = this.el.nativeElement.value;
    //this.el.nativeElement.value = initalValue.replace(/^0+/, 0);
    //if (initalValue !== this.el.nativeElement.value) {
    //  event.stopPropagation();
    //}
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode;  // k = event.charCode;  (Both can be used)
    if (!k || k === 8) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    if (new RegExp(/[a-zA-Z0-9\s]/).test(ch)) {
      return;
    }

    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  acceptNegativevalues(event: any): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^0-9\-]/g, '');
    if (value.includes('-')) {
      value = '-' + value.replace(/-/g, '');
    } else {
      value = value.replace(/-/g, '');
    }
    const isNegative = value.startsWith('-');
    const maxLength = isNegative ? 9 : 8;
    if (value.length > maxLength) {
      value = input.value = this._oldvalue;
    } else {
      this._oldvalue = value; // Save current valid value
      input.value = value;
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(value);
      }
    }
  }


  acceptOnlyNumbers(event: any): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove all non-digit characters
    value = value.replace(/[^0-9]/g, '');

    // Optional: Limit length if needed
    const maxLength = 8;
    if (value.length > maxLength) {
      value = input.value = this._oldvalue || '';
    } else {
      this._oldvalue = value;
      input.value = value;
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(value);
      }
    }
  }

  noSpecialChars(event: any) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode;  // k = event.charCode;  (Both can be used)
    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57)) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }
  //with sapces no special characters
  postCode_UK(event: any) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode;  // k = event.charCode;  (Both can be used)
    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 32 || k === 8 || (k >= 48 && k <= 57)) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }
  //phone number
  //with sapces no special characters
  phoneNumber_UK(event: any) {

    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode;  // k = event.charCode;  (Both can be used)
    const ch = String.fromCharCode(e.keyCode);
    if (new RegExp(/[0-9\(\)\-\s]{1,35}/).test(ch)) {
      return;
    }
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }
  Trim(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;

    // Allow navigation and editing keys
    const allowedKeys = ['Tab', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete'];
    if (allowedKeys.includes(key)) return;

    // Allow Arabic characters (optional)
    const arabicRegex = /[\u0600-\u06FF]/;
    if (arabicRegex.test(key)) return;

    // Block space only if it's at the beginning
    if (key === ' ') {
      const cursorPos = input.selectionStart ?? 0;

      if (cursorPos === 0) {
        event.preventDefault(); 
        return;
      }

      return; 
    }

    // Allow all non-whitespace characters
    const trimmedCharRegex = /^\S$/;
    if (!trimmedCharRegex.test(key)) {
      event.preventDefault(); 
    }
  }





  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (this.appInputRestriction === 'decimalOnly') {
      const input = (event.target as HTMLInputElement).value;

      // Allow numbers with max 2 decimal places
      const match = input.match(/^[-]?\d*(\.\d{0,2})?$/);
      if (!match) {
        event.preventDefault();
        const validPart = input.split('.')[0] + '.' + input.split('.')[1]?.slice(0, 2);
        this.el.nativeElement.value = validPart;
      }
    }
    if (this.appInputRestriction === 'DigitsNegativeOnly') {
      this.acceptNegativevalues(event);
    }
    if (this.appInputRestriction === 'acceptOnlyNumbers') {
      this.acceptOnlyNumbers(event);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {

    if (this.appInputRestriction === 'decimalOnly') {
      event.preventDefault();
      if (event.clipboardData) {
        let pastedInput = event.clipboardData.getData('text/plain');
        pastedInput = pastedInput.replace(/[^\d.-]/g, '');

        const validDecimal = /^-?\d+(\.\d{0,2})?$/.test(pastedInput);
        if (validDecimal) {
          const floatVal = parseFloat(pastedInput);
          const formatted = floatVal.toFixed(2);
          document.execCommand('insertText', false, formatted);
        } else {
          console.error('Invalid format in pasted input');
        }
      }
    }



    if (this.appInputRestriction == "postCode_UK" || this.appInputRestriction == "noSpecialChars") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[&\/\\#@,+()$~%.'":*?|\]\[<>{}-]/g, ''); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }

    if (this.appInputRestriction == "alphaNumeric") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[\W_]+/g, ''); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }

    if (this.appInputRestriction == "numericOnly") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          //.replace(/\D/g, ''); // keep digits only, remove non-digit characters
         .replace(/[^\d-]/g, '');
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }
    if (this.appInputRestriction === 'DigitsNegativeOnly') {
      this.acceptNegativevalues(event);
    }
    if (this.appInputRestriction === 'acceptOnlyNumbers') {
      this.acceptOnlyNumbers(event);
    }


    if (this.appInputRestriction == "addressTax") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[=~!\/\\#+^$%'"|_:;?<>\[\]{}@]/g, '').trim(); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }
    //dont allow these charecters
    if (this.appInputRestriction == "c40Status") {

      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[%£€‘^\[\]"”$#{\\}~+¬!*_|:<>?;=`]/g, '').trim(); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }



    //dont allow these charecters
    if (this.appInputRestriction == "hpage") {

      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[!_^;~`£€\/\@\#‘”|+$~%":\]\[*?<>={}\\\\]/g, '').trim(); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }


    if (this.appInputRestriction == "allowfewSpecialChars") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[!_^;\]\[£€~`\\\+$~":*?|=<>{}]/g, ''); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      }
    } else {
      console.error("Clipboard data is not available.");
    }
    //if (this.appInputRestriction == "ComapanyName") {
    if (this.appInputRestriction == "CompanyName") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[!_^;\]\[£€~`\\#+$~%":*?|=<>{}]/g, ''); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }
    if (this.appInputRestriction == "addressType") {
      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[!£$%\^\*\+€=_\{\}\[\];\:@~#?<>|\\]/g, ''); // get a post code string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }
    if (this.appInputRestriction == "allowMinusValue") {

      event.preventDefault();
      if (event.clipboardData) {
        const numeric: string = event.clipboardData
          .getData('text/plain').replace(/[^0-9\-]/g, '')
        if (!isNaN(Number(numeric))) {
          let maxlength: number = this.inputElement.nativeElement.maxLength;
          var decimalNum = numeric.split('.');
          var temp = decimalNum[0].substr(0, maxlength)
          const pastedInput: any = (temp);
          document.execCommand('insertText', false, pastedInput);
        }
      } else {
        console.error("Clipboard data is not available.");
      }

    }
    if (this.appInputRestriction == "phoneNumber_UK") {
      event.preventDefault();
      if (event.clipboardData) {
        const numeric: string = event.clipboardData
          .getData('text/plain').replace(/[^0-9\(\)\-\s]{1,35}/g, '')
        const pastedInput: any = (numeric)
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }

    } if (this.appInputRestriction == "HMRCNumber") {
      event.preventDefault();
      if (event.clipboardData) {
        const numeric: string[] = event.clipboardData
          .getData('text/plain').split('.');
        const pastedInput: string = numeric[0]
          .replace(/\D/g, ''); // get a digit-only string
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }

    if (this.appInputRestriction == "re-enterpassword") {
      event.preventDefault();
    }
        //dont allow these charecters
    if (this.appInputRestriction == "email") {

      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[%£€‘^\[\]"”$#{\\}~+¬!*_|:<>?;=`]/g, '').trim();
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }
    if (this.appInputRestriction == "onlyAlphabets") {

      event.preventDefault();
      if (event.clipboardData) {
        const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/[%£€‘^\[\]"”$#{\\}~+¬!*_|:<>?;=`]/g, '').trim();
        document.execCommand('insertText', false, pastedInput);
      } else {
        console.error("Clipboard data is not available.");
      }
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: ClipboardEvent) {
    

    if (this.appInputRestriction == "postCode_UK" || this.appInputRestriction == "noSpecialChars") {
      event.preventDefault();
     
      if (this.inputElement.nativeElement.value) {
        const pastedInput: string = this.inputElement.nativeElement.value
          .replace(/[&\/\\#@,+()$~%.'":*?|\]\[<>{}-]/g, ''); // get a post code string
        this.inputElement.nativeElement.value = pastedInput
      } else {
        console.error("Clipboard data is not available.");
      }
    }
  }
  @HostListener('change', ['$event'])
  onBlurOrChange(event?: Event): void {
    if (this.appInputRestriction === 'decimalOnly') {
      const input = this.el.nativeElement;
      const value = input.value;

      const number = parseFloat(value);
      if (!isNaN(number)) {
        if (number < 0) { input.value = '' }
        else {
          input.value = number.toFixed(2);
        }
      } else {
        input.value = null;
      }
    }
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    let allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', ' '];
    if (allowedKeys.includes(event.key))
      return;
  }
 
  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent): void {
    if (this.appInputRestriction === 'searchCharityCommission') {
      const input = event.target as HTMLInputElement;
      const value = input.value;

      let pastedText = event.clipboardData?.getData('text') || '';

      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;

      if (value.length === 0 && pastedText.startsWith(' ')) {
        pastedText = pastedText.trimStart();
      }

      let newValue =
        value.substring(0, start) +
        pastedText +
        value.substring(end);
      const isNumericOnly = /^[0-9]+$/.test(newValue);
      const maxLength = isNumericOnly ? 8 : 160;
      if (newValue.length > maxLength) {
        newValue = newValue.substring(0, maxLength);
      }

      event.preventDefault();
      input.value = newValue;

      const cursorPos = Math.min(start + pastedText.length, maxLength);
      input.setSelectionRange(cursorPos, cursorPos);
    }
    else {
      event.preventDefault();
    }
  
  }
 
  @HostListener('copy', ['$event'])
  blockCopy(event: ClipboardEvent): void {
    if (this.appInputRestriction != 'searchCharityCommission') {
      event.preventDefault();
    }
  }
 
  @HostListener('cut', ['$event'])
  blockCut(event: ClipboardEvent): void {
    event.preventDefault();
  }
}


